import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=26e2f906&scoped=true&"
import script from "./Wave.vue?vue&type=script&lang=ts&"
export * from "./Wave.vue?vue&type=script&lang=ts&"
import style0 from "./Wave.vue?vue&type=style&index=0&id=26e2f906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e2f906",
  null
  
)

export default component.exports